export function isInNativeWebView(): boolean {
  if (typeof window === 'undefined') return false
  const w = window as any
  return !!(
    w.ReactNativeWebView ||
    (typeof w.webkit === 'object' && w.webkit?.messageHandlers) ||
    w.Android
  )
}
